import getApiClient from '@/plugins/api-client'
import draggable from 'vuedraggable'
import BlockForm from '../BlockForm/Index'
import _ from 'lodash'
import Vue from 'vue'
import SimpleImageUploader from '@/components/SimpleImageUploader.vue'
import AceEditor from 'vuejs-ace-editor'
import { postStatuses } from '@/util/postStatuses'

export default {
  name: 'PageForm',
  components: {
    SimpleImageUploader,
    AceEditor,
    BlockForm,
    draggable,
  },
  data: () => {
    return {
      page: {
        title: null,
        blocks: [],
        jsonld: null,
      },
      imageUploaderKey: 'imageUploaderKey',
      api: null,
      id: null,
      blocks: [],
      showEditDialog: false,
      showAddDialog: false,
      editingBlock: null,
      blockSearchTerm: null,
      editBlockKey: null,
      postStatuses,
      errors: {},
      showAvailableBlocks: false,
    }
  },
  computed: {
    isJsonLdValid: function () {
      if (!this.page.jsonld) {
        return true
      }

      try {
        JSON.parse(this.page.jsonld)
        return true
      } catch (e) {
        return false
      }
    },
  },
  mounted: function () {
    this.api = getApiClient(this.$store)
    this.id = this.$route.params.id

    this.loadPage()
    this.loadBlocks()
  },
  methods: {
    codeEditorInit: function () {
      require('brace/mode/javascript')
      require('brace/mode/json')
      require('brace/mode/json')
      require('brace/theme/monokai')
    },
    loadPage: function () {
      if (!this.id) {
        return
      }
      this.api.get(`/pages/${this.id}`)
        .then(result => {
          if (!result.data.jsonld) {
            result.data.jsonld = '{}'
          }
          this.page = result.data
          if (!this.page.blocks) {
            Vue.set(this.page, 'blocks', [])
          }

          if (!this.page.picture) {
            Vue.set(this.page, 'picture', null)
          }

          if (!this.page.picture_images) {
            Vue.set(this.page, 'picture_images', {})
          }

          // eslint-disable-next-line camelcase
          if (this.page.picture_images?.thumbnail_400) {
            this.page.picture = this.page.picture_images.thumbnail_400
            this.imageUploaderKey = Math.random() * 1000
          }
        })
        .catch(error => {
          console.info(error)
        })
    },
    loadBlocks: function (search = null) {
      const params = {
        itemsPerPage: 8,
        pagination: true,
      }

      if (search) {
        params.title = search
        params.pagination = false
      }

      this.api.get('/blocks', {
        params: params,
      })
        .then(result => {
          this.blocks = result.data['hydra:member']
        })
        .catch(error => {
          console.info(error)
        })
    },
    save: function () {
      let method = 'post'
      let path = '/pages'
      const headers = {}
      if (this.id) {
        method = 'patch'
        path = `/pages/${this.id}`
        headers['Content-Type'] = 'application/merge-patch+json'
      }

      const data = this.prepareData(this.page)

      this.api[method](path, data, { headers })
        .then(result => {
          this.$store.commit('app/raiseSuccess', 'Página salva com sucesso')
          this.$router.push({
            name: 'EditPage',
            params: { id: result.data.slug },
          })
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.parseErrors(error.response.data)
          }
          this.$store.commit('app/raiseError', 'Falha ao salvar página')
        })
    },

    prepareData: function (data) {
      const value = JSON.parse(JSON.stringify(data))

      // eslint-disable-next-line no-unused-expressions
      value.blocks = value?.blocks?.map(block => block['@id'])

      value.pageBlocks = []
      let weight = 0

      // eslint-disable-next-line no-unused-expressions
      value.blocks?.forEach(block => {
        value.pageBlocks.push({
          block: block,
          weight: weight,
        })

        weight++
      })

      if (value?.picture && !value?.picture?.includes('base64')) {
        value.picture = undefined
      }

      return value
    },

    removePageBlock: function (index) {
      this.page.blocks.splice(index, 1)
    },
    addBlock: function () {
      this.showAddDialog = true
    },
    editBlock: function (block) {
      this.editingBlock = block
      this.showEditDialog = true
      this.editBlockKey = Math.random() * 1000
    },
    cancelEditBlock: function () {
      this.editingBlock = null
      this.showEditDialog = false
    },
    cancelAddBlock: function () {
      this.showAddDialog = false
    },
    updateBlock: function () {
      this.editingBlock = null
      this.showEditDialog = false
    },
    appendBlock: function (block) {
      this.loadBlocks()
      this.page.blocks.push(block)
      this.showAddDialog = false
    },
    prependMetaTag: function () {
      if (!this.page.metadata) {
        Vue.set(this.page, 'metadata', [])
      }
      this.page.metadata.unshift({
        name: null,
        content: null,
      })
    },
    parseErrors (errors) {
      const self = this

      errors.violations.forEach(violation => {
        Vue.set(self.errors, violation.propertyPath, violation.message)
      })
    },
  },
  watch: {
    blockSearchTerm: function (value) {
      this._debouncedLoadBlocks = this._debouncedLoadBlocks || _.debounce((value) => this.loadBlocks(value), 300)
      this._debouncedLoadBlocks(value)
    },
  },
}
